import actions from './actions';

const state = {
  homePagePopupBanner: null,
};

const mutations = {
  SET_HOME_PAGE_POPUP_BANNER: (state, banner) => {
    state.homePagePopupBanner = banner;
  },
};

const getters = {
  homePagePopupBanner: state => state.homePagePopupBanner,
};

const store = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default store;
